export const InDevelopmentView = () => {
  return (
    <div className="w-full h-[300px] flex flex-col gap-2 items-center justify-center col-span-6">
      <h2 className="text-xl font-semibold">Coming soon</h2>
      <p className="text-sm">This feature is in development</p>
    </div>
  );
};
